import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "../screens/Home";
import BookingDetail from "../screens/BookingDetail";
import FilterPage from "../screens/FilterPage";
import Payment from "../screens/Payment";
import PaymentSuccess from "../screens/PaymentResult/PaymentSuccess";
import PaymentFailed from "../screens/PaymentResult/PaymentFailed";
import Header from "../components/Header";
import Footer from "../components/Footer";
import InvalidKey from "../components/InvalidKey";
import DayPass from "../screens/DayPass";
import DayPassBookNow from "../screens/DayPassBookNow";
import DayPassPayment from "../screens/DayPassPayment";
import { DayPassContextProvider } from "../stores/DayPassContextProvider";

function AppRoutes() {
  return (
    <Router>
      <DayPassContextProvider> {/* Place the context provider at the top level */}
        {/* Include the Header component */}
        {/* <Header /> */}

        <Routes>
          <Route path={`/:accessKey`} element={<Home />} />
          <Route
            path={`/meeting-room`}
            element={
              <Navigate
                replace
                to={
                  process.env.REACT_APP_ENV !== "Production"
                    ? `/ac8e79e897e9d4f76808c62d3c7faa3b:6c357f`
                    : `/a1490c20c96d4f3b05677d88dee1d4b3:cae8`
                }
              />
            }
          />
          <Route
            path={`/booking-detail/:accessKey`}
            element={<BookingDetail />}
          />
          <Route path={`/day-pass/:accessKey`} element={<DayPass />} />
          <Route
            path={`/day-pass/book-now/:accessKey`}
            element={<DayPassBookNow />}
          />
          <Route
            path={`/day-pass/book-now/payment/:accessKey`}
            element={<DayPassPayment />}
          />
          <Route path={`/filter-page/:accessKey`} element={<FilterPage />} />
          <Route
            path={`/payment/success/:accessKey/:txn_id`}
            element={<PaymentSuccess />}
          />
          <Route
            path={`/payment/failed/:accessKey/:txn_id`}
            element={<PaymentFailed />}
          />
          <Route path={`/payment/:accessKey`} element={<Payment />} />
          <Route path={`/:accessKey`} element={<InvalidKey />} />
        </Routes>

        {/* Include the Footer component */}
        <Footer />
      </DayPassContextProvider>
    </Router>
  );
}

export default AppRoutes;
